'use client'

import * as React from 'react'
import { cn } from '../../lib/utils'
import * as RechartsPrimitive from 'recharts'

const THEMES = { light: '', dark: '.dark' }

const ChartContext = React.createContext(null)

function useChart() {
  const context = React.useContext(ChartContext)
  if (!context) throw new Error('useChart must be used within a <ChartContainer />')
  return context
}

function ChartContainer({ id, className, children, config, ...props }) {
  const uniqueId = React.useId()
  const chartId = `chart-${id || uniqueId.replace(/:/g, '')}`

  return (
    <ChartContext.Provider value={{ config }}>
      <div
        data-slot="chart"
        data-chart={chartId}
        className={cn(
          "[&_.recharts-cartesian-axis-tick_text]:fill-muted-foreground [&_.recharts-cartesian-grid_line[stroke='#ccc']]:stroke-border/50 [&_.recharts-curve.recharts-tooltip-cursor]:stroke-border flex aspect-video justify-center text-xs [&_.recharts-layer]:outline-hidden [&_.recharts-sector]:outline-hidden [&_.recharts-surface]:outline-hidden",
          className
        )}
        {...props}
      >
        <ChartStyle id={chartId} config={config} />
        <RechartsPrimitive.ResponsiveContainer>{children}</RechartsPrimitive.ResponsiveContainer>
      </div>
    </ChartContext.Provider>
  )
}

const ChartStyle = ({ id, config }) => {
  const colorConfig = Object.entries(config || {})?.filter(([, cfg]) => cfg?.theme || cfg?.color)
  if (!colorConfig?.length) return null

  return (
    <style
      dangerouslySetInnerHTML={{
        __html: Object.entries(THEMES)
          ?.map(
            ([theme, prefix]) => `
${prefix} [data-chart=${id}] {
${colorConfig
  ?.map(([key, itemConfig]) => {
    const color = itemConfig?.theme?.[theme] || itemConfig?.color
    return color ? `  --color-${key}: ${color};` : null
  })
  ?.join('\n')}
}
`
          )
          ?.join('\n'),
      }}
    />
  )
}

const ChartTooltip = RechartsPrimitive.Tooltip

export { ChartContainer, ChartTooltip, ChartStyle, useChart }